import * as React from 'react';

var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
var SvgCreditCardOutline = function SvgCreditCardOutline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.75 12.504C6.33579 12.504 6 12.8398 6 13.254C6 13.6682 6.33579 14.004 6.75 14.004H9.75C10.1642 14.004 10.5 13.6682 10.5 13.254C10.5 12.8398 10.1642 12.504 9.75 12.504H6.75Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2 6.75387C2 5.2349 3.23088 4.00293 4.75 4.00293H19.248C20.7637 4.00293 21.9945 5.23006 21.9957 6.74745C21.9962 7.51752 21.9962 8.28777 21.9961 9.05759L21.9961 9.7524V17.252C21.9961 18.771 20.7652 20.0029 19.2461 20.0029H4.75C3.23089 20.0029 2 18.771 2 17.252V6.75387ZM3.5 10.5024H20.4961V17.252C20.4961 17.9432 19.9362 18.5029 19.2461 18.5029H4.75C4.05997 18.5029 3.5 17.9432 3.5 17.252V10.5024ZM4.75 5.50293C4.05998 5.50293 3.5 6.06266 3.5 6.75387V9.0024H20.4961L20.4954 6.72275C20.481 6.04651 19.9282 5.50293 19.248 5.50293H4.75Z"
  })));
};

export { SvgCreditCardOutline as ReactComponent };
//# sourceMappingURL=credit--card-outline.svg.js.map
